import { notification } from 'antd'
import ApiEndPoints, { getLoggedInUserInfo } from 'utils'
import apiClient from '../index'

export const uploadDocument = (data) => apiClient.post('media', data)
export const updateDocument = (data) => apiClient.patch('media/updateMedia', data)
export const uploadAprExcel = (data) => apiClient.post('attendance/uploadApr', data)
export const uploadAttendanceExcel = (data) => apiClient.post('attendance/markAttendance', data)
export const HolidayDocument = (data) => apiClient.post('holidays/addHoliday', data)

export const getDocument = async (mediaType, searchEmployee, year, skip, limit) => {
  try {
    return await apiClient.get('/media', {
      params: {
        mediaType,
        searchEmployee,
        year,
        skip,
        limit,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}
export const getSelectedEmpDocument = async (userId, skip, limit) => {
  try {
    return await apiClient.get('/media/selectedEmpDoc', {
      params: {
        userId,
        skip,
        limit,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}
export const deleteDocument = async (id) => {
  const empId = getLoggedInUserInfo()?.empId

  if (!empId) {
    notification.error({
      message: 'Error',
      description: 'User is not logged in or empId is missing.',
    })
    return null
  }

  try {
    const response = await apiClient.patch('media/documentDelete', {
      id,
      empId,
    })

    if (response?.data?.statusCode !== 200) {
      notification.error({
        message: 'Error',
        description: response?.data?.error || 'Something went wrong',
      })
    }
    return response
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}

export const salarySlip = async (value) => {
  const empId = getLoggedInUserInfo()?.empId
  const userRole = getLoggedInUserInfo()?.userRole
  const { mediaType, year } = value
  try {
    return apiClient.get('media/salarySlip', {
      params: {
        empId,
        mediaType,
        year,
        userRole,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}
export const getEmployeeDocumentURL = async (id) => {
  try {
    return await apiClient.get(`${ApiEndPoints.FETCH_EMP_DOCUMENT_URL}/${id}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getEmpDocuments = async (skip, limit, empId) => {
  try {
    return await apiClient.get(`media/${empId}`, {
      params: {
        skip,
        limit,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}
